import { render, staticRenderFns } from "./changewordtitle.vue?vue&type=template&id=107f96a4&scoped=true&"
import script from "./changewordtitle.vue?vue&type=script&lang=js&"
export * from "./changewordtitle.vue?vue&type=script&lang=js&"
import style0 from "./changewordtitle.vue?vue&type=style&index=0&id=107f96a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107f96a4",
  null
  
)

export default component.exports